import { useTranslation } from "react-i18next";
import { Copy, Navigation } from "../../components";
import { useModal } from "../../shared/contexts";
import { Box, PageContainer, Typography } from "../../shared/ui";
import { useProvablyFairStore } from "../../store/provablyFairStore";
import css from "./ProvablyFair.module.scss";

export const ProvablyFair = () => {
  const { t } = useTranslation();
  const { openModal } = useModal();
  const { nextClientSeed, nextServerHash } = useProvablyFairStore();

  return (
    <div>
      <Navigation title={t("provably_fair.title").toUpperCase()} />
      <PageContainer className={css.container}>
        <Typography className={css.title} color="header-small">
          {t("provably_fair.description_text")}
        </Typography>
        <div className={css.provablyFairButtonContainer}>
          <button
            className={css.provablyFairButton}
            onClick={() => {
              openModal("ProvablyFairDescription");
            }}
          >
            <Typography className={css.btnText} color="orange">
              {t("provably_fair.what_is_provably_fair")}
            </Typography>
          </button>
        </div>
        <Box
          className={css.nextSeed}
          display="flex"
          direction="column"
          align="start"
        >
          <Typography className={css.descr} color="light-grey">
            {t("provably_fair.next_seed")}
          </Typography>
          <Copy copyText={nextClientSeed || "-"} />
        </Box>
        <Box
          className={css.nextHash}
          display="flex"
          direction="column"
          align="start"
        >
          <Typography className={css.descr} color="light-grey">
            {t("provably_fair.server_next_hash")}
          </Typography>
          <Copy copyText={nextServerHash || "-"} />
        </Box>

        {/* <Box>
          <Typography className={css.title2} color="header-small">
            Select bet to check
          </Typography>
        </Box>
        <TableContainer className={css.tableContainer}>
          <TableHeader columns={tableHeader} />
          <div className={css.betList}>
            {loading ? (
              <Typography variant="caption2" color="header-small">
                Loading…
              </Typography>
            ) : bets?.length ? (
              bets.map((b) => (
                <div key={String(b.betId)} style={{ padding: 4 }}>
                  <Typography variant="caption2" color="light-grey">
                    #{String(b.roundId)} ·{" "}
                    {new Date(Number(b.timestamp || 0)).toLocaleString()} · Bet
                    $ {Number(b.betAmount ?? 0).toFixed(2)} · x
                    {Number(b.multiplier ?? 0).toFixed(2)} · ${" "}
                    {Number(b.payout ?? 0).toFixed(2)}
                  </Typography>
                </div>
              ))
            ) : (
              <Typography variant="caption2" color="header-small">
                No data
              </Typography>
            )}
          </div>
        </TableContainer> */}
      </PageContainer>
    </div>
  );
};
